import React, { useState, useEffect } from 'react';
import { Typography, Box } from '@mui/material';
import TextBox from '../../components/TextBox';
import AutoCompleteBank from '../../components/AutoCompleteBank';
import ButtonSubmit from '../../components/ButtonSubmit';
import CustomSnackBar from '../../components/CustomSnackBar';
import { Add, Edit, LocalOffer } from '@mui/icons-material';
import API from '../../services/api';
import TextArea from '../../components/TextArea';

export default function EditPrice({ product = 0, price = 0, setOpen, getDataProducts }) {
  const uri = `/price/${price}/`;
  const formatDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).toISOString().split('T')[0];
  };

  const [openSnack, setOpenSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("info");
  const [formData, setFormData] = useState({
    comment: '',
    dateBegin: formatDate(new Date()),
    price: 0,
    priceType_id: '',
    product: product,
  });
  const [selectedItem, setSelectedItem] = useState(null);
  const [priceTypes, setPriceTypes] = useState([]);

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const loadPriceTypes = async () => {
    try {
      const { data } = await API.get('catalogs/price-types/');
      const list = Array.isArray(data) ? data : (Array.isArray(data?.results) ? data.results : []);
      setPriceTypes(list);
    } catch (error) {
      console.log(error);
      setPriceTypes([]);
    }
  };

  const getData = async () => {
    try {
      const response = await API.get(uri);
      const ptype = response.data?.priceType || {};
      setFormData({
        comment: response.data?.comment || '',
        dateBegin: response.data?.dateBegin || formatDate(new Date()),
        price: response.data?.price || 0,
        priceType_id: ptype.id || '',
        product: response.data?.product || product,
      });
      setSelectedItem(ptype.id ? { id: ptype.id, name: ptype.name } : null);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectChange = (name, value) => {
    setSelectedItem(value);
    setFormData(prevState => ({
      ...prevState,
      [`${name}_id`]: value ? value.id : '',
    }));
  };

  useEffect(() => {
    loadPriceTypes();
    if (price !== 0) {
      getData();
    }
  }, [price]);

  const submitData = async (e) => {
    e.preventDefault();
    try {
      if (price !== 0) {
        await API.patch(uri, formData);
        setSnackMessage("¡Actualizado con éxito!");
      } else {
        await API.post('price/', formData);
        setSnackMessage("¡Creado con éxito!");
      }
      setOpenSnack(true);
      setSnackSeverity("success");
      setTimeout(() => {
        setLoading(false);
        setOpen(false);
      }, 1500);
      await getDataProducts();
    } catch (error) {
      setOpenSnack(true);
      console.log(error);
      setSnackMessage("Intente de nuevo");
      setSnackSeverity("error");
      setLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={submitData}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 500,
        margin: '0 auto',
        gap: 0,
        p: 0
      }}
    >
      <Typography variant='subtitle2' sx={{ textAlign: 'center' }}>
        Precio activo desde: {
          formData.dateBegin
            ? (new Date().toDateString() === new Date(`${formData.dateBegin}T00:00:00`).toDateString()
              ? 'Hoy'
              : new Date(formData.dateBegin).toLocaleDateString())
            : ''
        }
      </Typography>

      <TextBox
        label='Precio'
        type='number'
        icon={LocalOffer}
        required
        maxLength={10}
        name={'price'}
        errorMessage='Campo requerido'
        onChange={handleChange}
        newValue={formData.price}
        sx={{ width: '100%' }}
      />

      <AutoCompleteBank
        options={priceTypes}
        getOptionLabel={(option) => option.name || ''}
        onChange={(event, value) => handleSelectChange("priceType", value)}
        name={"priceType"}
        value={selectedItem}
        label='Tipo de precio'
        sx={{ width: '100%' }}
      />

      <TextArea 
        name={"comment"} 
        onChange={handleChange} 
        newValue={formData.comment}
        sx={{ width: '100%' }}
      />

      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <ButtonSubmit
          name={price === 0 ? 'Crear' : 'Actualizar'}
          icon={price === 0 ? Add : Edit}
          loading={loading}
          onClick={submitData}
          sx={{ width: '100%', maxWidth: 200 }}
        />
      </Box>

      {openSnack && (
        <CustomSnackBar
          open={openSnack}
          setOpen={setOpenSnack}
          message={snackMessage}
          severity={snackSeverity}
        />
      )}
    </Box>
  );
}
